import React, { useRef, useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./sliderThumbs.css";
import PropTypes from "prop-types";
import nextArrow from '../../assets/arrow_next.svg';
import prevArrow from '../../assets/arrow_prev.svg';
import PlayIcon from '../../assets/play_arrow.png';
import { processUrl, isVimeoVideoExists } from '../../helpers/formatterHelper';
import { getVimeoToken } from '../../api/docCenterApi';

const ThumbnailSlider = ({ marketPlace = { media: [] } }) => {
    const mainSliderRef = useRef(null);
    const thumbSliderRef = useRef(null);
    const [openModal, setOpenModal] = useState(false);
    const [previewImage, setPreviewImage] = useState("");
    const [type, setType] = useState(0);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [videoUrl, setVideoUrl] = useState("");
    const [processedItems, setProcessedItems] = useState([]);
    const [vimeoToken, setVimeoToken] = useState("");

    useEffect(() => {
        const fetchVimeoToken = async () => {
            try {
                const response = await getVimeoToken();
                setVimeoToken(response.data);
            } catch (error) {
                console.error("Failed to fetch Vimeo token:", error);
            }
        };
        fetchVimeoToken();
    }, []);

    useEffect(() => {
        const processMediaItems = () => {
            if (!marketPlace?.media?.length) return;

            const items = marketPlace.media.map((item) => {
                if (item.mediaItem?.videoType === 1) {
                    const videoExists = isVimeoVideoExists(item.mediaItem?.videoId, vimeoToken);
                    return { ...item, videoExists };
                }
                return item;
            });

            const filteredItems = items.filter((item) =>
                (item.videoExists && item.mediaItem?.videoType === 1) ||
                item.mediaItem?.videoType === 0 ||
                item.mediaItem?.type === 0
            );

            setProcessedItems(filteredItems);
        };
        processMediaItems();
    }, [marketPlace, vimeoToken]);

    useEffect(() => {
        if (mainSliderRef.current && thumbSliderRef.current) {
            mainSliderRef.current.slickGoTo(0);
        }
    }, [processedItems]);

    const mainSliderSettings = {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: true,
        asNavFor: thumbSliderRef.current,
    };
    const thumbSliderSettings = {
        slidesToShow: 1,
        slidesToScroll: 1,
        asNavFor: mainSliderRef.current,
        dots: true,
        centerMode: true,
        focusOnSelect: true,
        arrows: false,
        infinite: false,
        variableWidth: true,
    };
    const handleVideoOpen = (mediaItem, index) => {
        setOpenModal(true);
        setPreviewImage(mediaItem?.previewsrc);
        setType(mediaItem?.type);

        if (mediaItem?.type === 1) {
            const { id, type, urlval } = processUrl(mediaItem?.videoSrc);
            const baseUrls = {
                youtube: `https://www.youtube.com/embed/${id}?rel=0&autoplay=1`,
                vimeo: `https://player.vimeo.com/video/${id}?title=0&byline=0&portrait=0&${urlval ? `${urlval}&` : ''}autoplay=true&loop=1`,
                htmlVideo: mediaItem?.videoSrc,
            };
            setVideoUrl(baseUrls[type] || "");
        }

        setCurrentIndex(index);
    };

    const navigateSlide = (direction) => {
        const newIndex = (currentIndex + direction + processedItems.length) % processedItems.length;
        const media = processedItems[newIndex];
        if (media) {
            handleVideoOpen(media.mediaItem, newIndex);
        }
    };

    const getThumbnailClass = () => {
        switch (processedItems.length) {
            case 1:
                return "one-image";
            case 2:
                return "two-images";
            case 3:
                return "three-images";
            default:
                return "";
        }
    };

    console.log('processedItems', processedItems);
    return (
        <div style={{ width: "100%", margin: "0 auto" }}>
            {/*Main Slider*/}
            <Slider {...mainSliderSettings} asNavFor={thumbSliderRef.current} ref={(slider) => (mainSliderRef.current = slider)} className="main-slider">
                {marketPlace.media.map((item, index) => (
                    <div key={index}>
                        <img src={item?.mediaItem?.previewsrc} alt={`Slide ${index + 1}`} style={{ width: "100%", height: "auto", borderRadius: "8px" }} />
                        {item.mediaItem?.type == 1 && (
                            <div className="play-icon" onClick={() => handleVideoOpen(item.mediaItem, index)}>
                                <img src={PlayIcon} alt="play" />
                            </div>
                        )}
                    </div>
                ))}
            </Slider>

            {/*Thumb slider*/}
            {processedItems.length >= 5 ? (
                <Slider {...thumbSliderSettings} asNavFor={mainSliderRef.current} ref={(slider) => (thumbSliderRef.current = slider)} style={{ marginTop: "20px" }} className="thumb-slider">
                    {marketPlace.media.map((item, index) => (
                        <div key={index} className="slick-slide-wrap shadow-thumb-slider">
                            <img src={item?.mediaItem?.previewsrc} alt={`Thumbnail ${index + 1}`} style={{
                                width: "80px",
                                height: "auto",
                                margin: "0 auto",
                                cursor: "pointer",
                                borderRadius: "4px",
                                border: "2px solid #ccc",
                            }} />
                        </div>
                    ))}
                </Slider>
            ) : (
                    <div className={`thumbnail-container ${getThumbnailClass()}`} style={{ alignItems: "stretch", display: "flex", gap: "10px", justifyContent: "flex-start", marginTop: "20px" }}>
                        {processedItems.map((item, index) => (
                            <div key={index} className="thumbnail-item">
                                <img
                                    src={item?.mediaItem?.previewsrc}
                                    alt={`Thumbnail ${index + 1}`}
                                    style={{
                                        width: "80px",
                                        height: "auto",
                                        maxHeight: "66px",
                                        minHeight: "66px",
                                        objectFit: "cover",
                                        cursor: "pointer",
                                        borderRadius: "4px",
                                        border: "2px solid #ccc",
                                    }}
                                    onClick={() => mainSliderRef.current?.slickGoTo(index)}
                                />
                            </div>
                        ))}
                    </div>
            )}

            <div className="directory-wrap event-detail-wrap">
                {openModal && (
                    <div className="video-modal">
                        <div className="close-modal" onClick={() => setOpenModal(false)}>
                            <span className="material-symbols-rounded">close</span>
                        </div>
                        <div className="video-event-wrap news-video">
                            {type === 0 ? (
                                <img src={previewImage} alt="video" className="video-box" />
                            ) : (
                                <iframe
                                    width="560"
                                    height="315"
                                    src={videoUrl}
                                    title="Video"
                                    allow="autoplay;"
                                    frameBorder="0"
                                    allowFullScreen
                                ></iframe>
                            )}
                        </div>

                        {processedItems.length > 1 && (
                            <div className="video-arrows-wrap">
                                <div className="arrow-modal prev" onClick={() => navigateSlide(-1)}>
                                    <span className="arrow-wrap">
                                        <img src={prevArrow} alt="prev item" />
                                    </span>
                                </div>
                                <div className="arrow-modal next" onClick={() => navigateSlide(1)}>
                                    <span className="arrow-wrap">
                                        <img src={nextArrow} alt="next item" />
                                    </span>
                                </div>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

ThumbnailSlider.propTypes = {
    marketPlace: PropTypes.shape({
        media: PropTypes.arrayOf(
            PropTypes.shape({
                mediaItem: PropTypes.shape({
                    previewsrc: PropTypes.string,
                    videoType: PropTypes.number,
                    videoSrc: PropTypes.string,
                    type: PropTypes.number,
                    videoThumbnailUrl: PropTypes.string,
                    videoId: PropTypes.string,
                }),
            })
        ),
    }),
};
export default ThumbnailSlider;
